import { AddressFormData } from '../types';

const toPascalCase = (str: string): string => {
  if (!str) return str;
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const makeAddressObj = (formState: AddressFormData): Record<string, unknown> => {
  return {
    ...(formState.Id ? { Id: formState.Id } : {}),
    Title: formState.Title,
    TypeId: formState.TypeId,
    Line1: formState.Line1 || '',
    Line2: formState.Line2 || ' ',
    City: toPascalCase(formState.City || ''),
    Province: (formState.Province || '').toUpperCase(),
    PostalCode: (formState.PostalCode || '').toUpperCase(),
    Country: formState.Country || '',
    CustomerId: formState.CustomerId,
    PatrolType: formState.PatrolType || '',
    Instructions: formState.Instructions || '',
    OnlineMapUrl: formState.OnlineMapUrl || '',
  };
};

export default makeAddressObj;
